
export default function diffInDays(date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
            Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
        (1000 * 60 * 60 * 24)
    );
};

// Function to sum all values in an object
export function sumObjectValues(obj) {
    let total = 0;
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            total += obj[key];
        }
    }
    return total;
};

// Function to calculate quotients between two list of objects
export const calculateQuotients = (list1, list2, valueKeys1, valueKeys2) => {
    const quotients = [];

    if (valueKeys1 == null || valueKeys2 == null || list1 == null || list2 == null) {
        return quotients
    }

    if (valueKeys1.length === 0 || valueKeys2.length === 0) {
        return quotients
    }

    // Iterate through the lists
    const minLength = Math.min(list1.length, list2.length);
    for (let i = 0; i < minLength; i++) {
        const item1 = list1[i];
        const item2 = list2[i];

        // Sum the value of the list of keys for list 2
        let value1Total = 0
        valueKeys1.map((valueKey1) => {
            if (item1[valueKey1]) {
                value1Total += item1[valueKey1]
            }
            return value1Total
        })

        // Sum the value of the list of keys for list 2
        let value2Total = 0
        valueKeys2.map((valueKey2) => {
            if (item2[valueKey2]) {
                value2Total += item2[valueKey2]
            }
            return value2Total
        })

        // Check so that denominator is not zero
        if (value2Total !== 0) {
            // Calculate the quotient and add it to the quotients list
            const quotient = value1Total / value2Total;
            quotients.push(quotient);
        } 
        // else {
        //     // Add null for invalid or missing values
        //     quotients.push(null);
        // }
    }

    return quotients;
};